module.exports = __webpack_public_path__ + "static/media/logo-footer.e24b743a.svg";